import axios from "axios";
import React, { Component } from "react";
import { getApiHeaderGuest } from "../../../utils/CommonFunctions";
import whiteLogo from "../../../assets/img/logo-white-small.png";
import {withRouter} from "react-router-dom";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

class PostPaidBiometric extends Component {
  state = {
    status: "pending",
    message:""
  };

  getStatusClass = () => {
    const { status } = this.state;
    if (status === "approved") return "approved";
    if (status === "pending") return "pending";
    return "rejected";
  };

  

  getIcon = () => {
    const { status } = this.state;
    if (status === "approved") return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    );
    if (status === "pending") return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    );
    return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    );
  };

  checkStatus = async (bio_id, bio_postpaid_actid) => {
    const payload = { 
       bio_id:bio_id,
      bio_wme_actid:bio_postpaid_actid, };
    const headers = await getApiHeaderGuest()
    try {
      const response = await axios.post(`${SERVER_URL}biometric/chk-bio-metric-status-postp`, payload, { headers });
      if (response.status === 200) {
        this.setState({ status: "approved" })
        this.setState({message:response.data?.message});
         if(response.data.data.confirm_api){
           this.activation(bio_id, bio_postpaid_actid,response.data.data.confirm_api)
         }

      }else{
        this.setState({ status: "rejected" });
      }

    } catch (error) { 
      const message = error?.response?.data?.message || "";
      this.setState({message: message });
      if (message.includes("failed")) {
        this.setState({ status: "rejected" });
      }
      this.setState({ status: "rejected" });
    }
  };



  activation =async(bio_id, bio_postpaid_actid,confirm_api)=>{
    const headers = await getApiHeaderGuest()
    this.setState({ status: "pending" });
    try {
    const payload = {
      bio_id:bio_id,
      bio_wme_actid:bio_postpaid_actid,
      session_id : 1,
      dvs_status : true         
    };

    const response = await axios.post(`${SERVER_URL}${confirm_api}`, payload, { headers });
    if(response.status===200){
      this.setState({ status: "approved" })
      this.setState({message:response.data?.message});
      setTimeout(() => {
        this.props.history.push("/home");
      }, 30000);
    }
      
    } catch (error) {
      const message= error.response?.data?.message||"Activation Failed please contact telsim support"
      this.setState({status:"rejected"})
      if(message){
        this.setState({message:message})
      }

      // setTimeout(() => {
      //   this.props.history.push("/home");
      // }, 30000);
      
    }
  }


  componentDidMount() {
    this.toggleChatVisibility();
    const searchParams = new URLSearchParams(window.location.search);
    const bio_id = searchParams.get("bio_id");
    const bio_postpaid_actid = searchParams.get("bio_wme_actid");
    if (bio_id && bio_postpaid_actid) {
      this.checkStatus(bio_id, bio_postpaid_actid);
    }
  }

  toggleChatVisibility() {
    const checkExist = setInterval(() => {
      const chat = document.getElementById("zsiq_float");
      if (chat) {
        chat.style.display = "none";
        clearInterval(checkExist);
      }
    }, 100);
  }

  render() {
    const { status } = this.state;
    const statusClass = this.getStatusClass();

    return (
      <>

        <div className="bio-page">
          <div className="biometric-header-wrapper">
            <div className="biometric-topbar">
              <div className="">
                <img className="biometric-logo" src={whiteLogo} alt="Telsim Logo" />
              </div>
            </div>

            <div className="biometric-title-row">
              <div className="biometric-title-accent" />
              {/* <h1 className="biometric-page-title">
                Biometric Verification Status
              </h1> */}
            </div>

          </div>

          <div className="bio-blob" />
          <div className="bio-card">
            <div className={`bio-accent-bar ${statusClass}`} />

            <div className="bio-header">
              <div className="bio-header-left">
                <div className="bio-logo-mark">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2a5 5 0 0 1 5 5v3H7V7a5 5 0 0 1 5-5z" />
                    <rect x="2" y="10" width="20" height="12" rx="3" />
                    <circle cx="12" cy="16" r="2" />
                  </svg>
                </div>
                <span className="bio-title">Biometric Verification</span>
              </div>
              <span className={`bio-badge ${statusClass}`}>  {status === "approved" ? "Approved": status === "pending" ? "Pending" : "Failed"}</span>
            </div>
            <div className="bio-body">
              <div className={`status-ring-outer ${statusClass}`}>
                <div className={`status-circle-inner ${statusClass}`}>
                  {this.getIcon()}
                </div>
              </div>

              <div className={`status-label ${statusClass}`}>
                {status === "approved" ? "Success" : status === "pending" ? "Pending" : "Failed"}
              </div>
              <p className="status-message">{this.state.message}</p>
            </div>


            <div className="bio-divider">
              <div className="bio-divider-line" />
              <div className="bio-divider-dot" />
              <div className="bio-divider-dot" />
              <div className="bio-divider-dot" />
              <div className="bio-divider-line" />
            </div>


            <div className="bio-info-row">
              <div className="bio-info-chip">
                <div className="bio-info-chip-label">Method</div>
                <div className="bio-info-chip-value">Facial Scan</div>
              </div>
              <div className="bio-info-chip">
                <div className="bio-info-chip-label">Attempts</div>
                <div className="bio-info-chip-value">1</div>
              </div>
              <div className="bio-info-chip">
                <div className="bio-info-chip-label">Session</div>
                <div className="bio-info-chip-value">Secure</div>
              </div>
            </div>


            <div className="bio-footer">
              <span className="bio-footer-text">Last updated: Just now</span>
              <div className={`bio-footer-dot ${statusClass}`} />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default  withRouter(PostPaidBiometric);